import Vue from "vue";
import Vuex from "vuex";

// import store dari fitur
import playground from "@/pages/playground";
import Example from "@/pages/Example";
import akun from "@/pages/akun";
import auth from "@/pages/auth";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import TopUp from "@/pages/TopUp";
import Riwayat from "@/pages/Riwayat";
// import login from "@/pages/login";
// import Riwayat from "@/pages/Riwayat";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: auth.store,
    dashboard: Dashboard.store,
    example: Example.store,
    playground: playground.store,
    scan: Scan.store,
    akun: akun.store,
    topup: TopUp.store,
    riwayat: Riwayat.store,
  },
});
